import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsImageBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsImageBlockEntity
